{
  "email": {
    "trains": {
      "notifications": {
        "services": "Huomaa, että lentosi ja junayhteytesi sallitut matkatavaramäärät voivat erota toisistaan. Katso tarkemmat tiedot alta.",
        "benefits": "Tähän reittiin sisältyy kumppanimme liikennöimä junayhteys. Huomaathan, että lipputyyppisi edut koskevat vain varauksessasi olevia lentoja."
      },
      "sustainabilityNote": "Valitsemalla junayhteyden pienennät matkustamisen hiilijalanjälkeä. Kiitos siitä!",
      "operatorInfo": {
        "W2": {
          "title": "Junayhteytesi Deutsche Bahnilla",
          "checkInNote": "Tee <b>lähtöselvitys junayhteydellesi</b> erikseen Deutsche Bahnin sivustolla käyttäen <b>Finnairin varaustunnusta</b>.",
          "buttonText": "Tee lähtöselvitys Deutsche Bahnin sivustolla",
          "checkInUrl": "https://rail-checkin.com/#/login"
        }
      }
    }
  },
  "services": {
    "productCards": {
      "confirm": "Vahvista"
    }
  }
}
